import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'keyValueOrder'
})
export class KeyValueOrderPipe implements PipeTransform {
  // key は 数字の文字列が前提（key: '1'）
  // 返り値の型 key を string | number にすると 引数の型チェックで弾かれるため、number が前提
  /**
   *
   * @param items
   */
  transform<T>(items: Record<string | number, T>): { key: number, value: T }[] {
    const ObjectArray: { key: number, value: T }[] = [];
    this.keysOf(items).sort((a, b) => {
      return 0;
    }).forEach((key, index) => {
      // key が 数字の文字列が前提だが、nanになった場合はindexをセット
      // key は保証されないが、valueは T型で返す
      const keyNumber = Number.isNaN(Number(key)) ? index : Number(key);
      ObjectArray.push({ key: keyNumber, value: items[key] });
    });
    return ObjectArray;
  }

  /**
   *
   * @param obj
   */
  keysOf<T extends Object>(obj: T): Array<keyof T> {
    return Array.from(Object.keys(obj)) as any;
  }
}
